import { createContext, useContext, useState, useCallback, useMemo } from 'react'

const CurrentTeamContext = createContext(null)

export function CurrentTeamProvider({ children }) {
  const [currentTeamId, setCurrentTeamId] = useState(null)

  const setTeam = useCallback((teamId) => {
    setCurrentTeamId(teamId)
  }, [])

  const clearTeam = useCallback(() => {
    setCurrentTeamId(null)
  }, [])

  const value = useMemo(() => ({ currentTeamId, setTeam, clearTeam }), [currentTeamId, setTeam, clearTeam])

  return (
    <CurrentTeamContext.Provider value={value}>
      {children}
    </CurrentTeamContext.Provider>
  )
}

export function useCurrentTeam() {
  const context = useContext(CurrentTeamContext)
  if (!context) {
    throw new Error('useCurrentTeam must be used within a CurrentTeamProvider')
  }
  return context
}
